import type { MinMaxType } from '@nf/types/common';

import { WebOddsType, IncDecType } from '@nf/utils-common/constants';
import BookingValueBloc from '@/features/betslip/betslip-booking/blocs/booking-value-bloc';

export interface BookingBlocs {
	oddsMinValueBloc: BookingValueBloc;
	oddsMaxValueBloc: BookingValueBloc;
}

export interface BookingValue {
	expectedValue: number;
	errorType: number;
	isOddsTypeMinValue: boolean;
	isOddsTypeMaxValue: boolean;
	isVerified: boolean;
}

export interface BookingOptions {
	betType: number;
	oddsType: WebOddsType;
	originalValue: number;
	minMaxType: MinMaxType;
}

export interface BookingInfo {
	isHandicap: boolean;
	isOU: boolean;
	isMalayOdds: boolean;
	isDecimalOdds: boolean;
	isFixedDecimal: boolean;
}

export interface BookingValueLimit {
	min: number;
	max: number;
}

export interface BookingValueOddsTypeLimit {
	min?: number;
	max?: number;
}

export enum OperationType {
	Plus,
	Minus
}

export enum BookingErrorType {
	IntervalRange = 100,
	Minimum = 101,
	Maximum = 102,
}

export interface BookingData {
	bookingOddsType: number;
	expectedMinOdds: number;
	expectedMaxOdds: number;
}

/**
 * payload for the POST API: /api/Reservation/CreateReservationTicket
 */
export interface ReservationCreationPayload {
	LeagueId: number;
	MatchId: number;
	SportType: number;
	BetType: number;
	HomeTeamId: number;
	AwayTeamId: number;
	OddsRanges: {
		Lower: number;
		Upper: number;
	};
	BetTeam: string;
	TeamScore: {
		Home: number;
		Away: number;
	},
	Hdp: number;
	Stake: number;
	IsLive: boolean;
}

/**
 * The type of the response value for the POST API: /api/Reservation/CreateReservationTicket
 */
export interface ReservationCreationResult {
	ErrorCode: number;
	Data: string;
	LicenseeErrorMessage: string;
}